import Button from 'components/Button'
import { View } from 'components/View'
import React from 'react'

/**
 * @param onClickName
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function WorkoutNameWrapper ({
  children,
  onClickName
}) {
  return (
    <Button
      isFullWidth
      style={{
        height: 'unset',
        maxWidth: 'unset'
      }}
      onClick={onClickName}
    >
      <View
        ac
        row
        style={{ justifyContent: 'space-between' }}
      >
        {children}
      </View>
    </Button>
  )
}
